import { useMemo, useState } from 'react';

import { WizardStepsContext, type WizardStepState } from './WizardStepsContext';

interface Props {
	children: React.ReactNode;
	defaultStepState?: WizardStepState;
}

export const WizardStepsProvider = ({
	children,
	defaultStepState = {} as WizardStepState,
}: Props) => {
	const [stepState, setStepState] = useState<WizardStepState>(defaultStepState);
	const [isLocked, setIsLocked] = useState<boolean>(false);

	const value = useMemo(
		() => ({ stepState, setStepState, isLocked, setIsLocked }),
		[stepState, setStepState, isLocked, setIsLocked]
	);

	return <WizardStepsContext.Provider value={value}>{children}</WizardStepsContext.Provider>;
};
